import clsx from 'clsx';

import { CoreBadgeProps } from '../shared/types/badge.types';

import styles from './badge.module.scss';

function CoreBadge({
  isDisabled = false,
  testId,
  text,
  variant = 'primary',
  ...rest
}: CoreBadgeProps) {
  const className = clsx(
    styles['core-badge'],
    styles[`core-badge-${variant}`],
    isDisabled && styles['disabled']
  );

  return (
    <div {...rest} data-testid={testId} className={className}>
      {text && <span className={styles['core-badge-text']}>{text}</span>}
    </div>
  );
}

export default CoreBadge;
